import { useGetAnalysisSaveActionType } from '@modules/analysis/hooks/useGetAnalysisSaveActionType';
import { AnalysisActionType } from '@modules/analysis/types';
import { CanAccess } from '@modules/common/components/CanAccess';
import { SaveSearchAction } from '@modules/feed/components/SearchAnalysisToolbar/Actions/SaveSearchAction';
import { UpdateSearchAction } from '@modules/feed/components/SearchAnalysisToolbar/Actions/UpdateSearchAction';
import { PermissionOperation, PermissionResource } from 'generated/graphql';

export const SaveSearchActions = () => {
  const actionType = useGetAnalysisSaveActionType();

  const renderSaveAction = () => {
    switch (actionType) {
      case AnalysisActionType.SAVE:
        return <SaveSearchAction actionType={AnalysisActionType.SAVE} />;
      case AnalysisActionType.SAVE_AS:
        return <SaveSearchAction actionType={AnalysisActionType.SAVE_AS} />;
      default:
        return <UpdateSearchAction />;
    }
  };

  return (
    <CanAccess
      resource={PermissionResource.Artefact}
      operation={PermissionOperation.Write}
    >
      {renderSaveAction()}
    </CanAccess>
  );
};
